/**
 * Auth funnel helpers for GA4 events sent via sendTrackingEvent / gtag.
 * Event names live in trackingEvent.js (TRACKING_EVENTS).
 */

import { classifyFromPage } from '../util/authRedirect';
import { getActiveLocale } from '../util/locale';
import { detectEmbeddedWebView, getWebviewAppName } from '../util/userAgent';

export const classifyLoginFailureReason = error => {
  if (!error) {
    return 'unknown';
  }
  const status = error.status || error.response?.status;
  if (status === 429) {
    return 'rate_limited';
  }
  if (status === 401 || status === 403) {
    return 'invalid_credentials';
  }
  if (status && status >= 500) {
    return 'server_error';
  }
  const message = `${error.message || ''}`.toLowerCase();
  if (status === 0 || message.includes('network') || message.includes('failed to fetch')) {
    return 'network';
  }
  return 'unknown';
};

export const getAuthFunnelParams = ({
  tab,
  isFreeContentFlow = false,
  from,
  language,
  extra = {},
} = {}) => {
  const webview = detectEmbeddedWebView();
  return {
    tab: tab || 'unknown',
    is_free_content_flow: !!isFreeContentFlow,
    from_page: classifyFromPage(from),
    webview: webview.app || 'none',
    language: language || getActiveLocale(),
    ...extra,
  };
};

export const getWebviewFunnelParams = ({ isWebview, extra = {} } = {}) => ({
  is_webview: typeof isWebview === 'boolean' ? isWebview : detectEmbeddedWebView().isWebView,
  webview: getWebviewAppName(),
  ...extra,
});
